



import Vue from "vue";
import postscribe from "postscribe";
import config from "@/config";

export default Vue.extend({
    name: "im-service",
    props: {
        imUrl: {
            type: String,
            required: false
        },
        id: {
            type: String,
            required: false,
            default: "im"
        }
    },
    computed: {
        url() {
            return this.imUrl || config.IM_URL;
        }
    },
    beforeDestroy() {
        if (
            this["$route"].path.startsWith("/my") ||
            this["$route"].path.startsWith("/login") ||
            this["$route"].path.startsWith("/registry") ||
            this["$route"].path.startsWith("/reset-password") ||
            this["$route"].path.endsWith("/registration")
        ) {
            const querySelector = document.querySelector("#lim_mobile_chat");
            if (null != querySelector) {
                querySelector.remove();
            }
        }
    },
    mounted() {
        /* eslint-disable */
        postscribe(`#${this["id"]}`, `<script src="${this["url"]}"><\/script>`);
        /* eslint-disable */
    }
});
